module.exports = __webpack_public_path__ + "static/img/h36.405b72c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h36.jpg
// module id = 0i+6
// module chunks = 0